<p-skeleton *ngIf="isLoading" height="8rem" class="mb-4"></p-skeleton>

<div *ngIf="!isLoading" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6">
  <div class="card mb-0">
    <div class="flex justify-between">
      <div>
        <span class="block text-muted-color font-medium mb-2">Patients</span>
        <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
          {{ stats.patients }}
        </div>
      </div>
      <div
        class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border"
        style="width: 2.5rem; height: 2.5rem"
      >
        <i class="pi pi-users text-blue-500 !text-xl"></i>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="flex justify-between">
      <div>
        <span class="block text-muted-color font-medium mb-2">Caregivers</span>
        <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
          {{ stats.caregivers }}
        </div>
      </div>
      <div
        class="flex items-center justify-center bg-orange-100 dark:bg-orange-400/10 rounded-border"
        style="width: 2.5rem; height: 2.5rem"
      >
        <i class="pi pi-user-plus text-orange-500 !text-xl"></i>
      </div>
    </div>
  </div>
  <div class="card mb-0">
    <div class="flex justify-between">
      <div class="flex-1">
        <span class="block text-muted-color font-medium mb-2">{{ 'appointments' | dynamicText | async }}</span>
        <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
          {{ stats.appointments }}
        </div>
      </div>
      <div
        class="flex items-center justify-center bg-cyan-100 dark:bg-cyan-400/10 rounded-border ml-4"
        style="width: 2.5rem; height: 2.5rem"
      >
        <i class="pi pi-calendar text-cyan-500 !text-xl"></i>
      </div>
    </div>
  </div>
  <div class="card mb-0">
    <div class="flex justify-between">
      <div>
        <span class="block text-muted-color font-medium mb-2">Caregiver</span>
        <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">${{ stats.totalPaid }}</div>
      </div>
      <div
        class="flex items-center justify-center bg-green-100 dark:bg-green-400/10 rounded-border"
        style="width: 2.5rem; height: 2.5rem"
      >
        <i class="pi pi-user text-green-500 !text-xl"></i>
      </div>
    </div>
  </div>
  <div class="card mb-0">
    <div class="flex justify-between">
      <div>
        <span class="block text-muted-color font-medium mb-2">Patient</span>
        <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">${{ stats.totalReceived }}</div>
      </div>
      <div
        class="flex items-center justify-center bg-red-100 dark:bg-red-400/10 rounded-border"
        style="width: 2.5rem; height: 2.5rem"
      >
        <i class="pi pi-credit-card text-red-500 !text-xl"></i>
      </div>
    </div>
  </div>
  <div class="col-span-1">
    <div class="card mb-0">
      <div class="flex justify-between">
        <div>
          <span class="block text-muted-color font-medium mb-2">Earnings</span>
          <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">${{ stats.balance }}</div>
        </div>
        <div
          class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-border"
          style="width: 2.5rem; height: 2.5rem"
        >
          <i class="pi pi-dollar text-purple-500 !text-xl"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Warning Section -->

<div *ngIf="!isLoading && hasWarnings()" class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-1">
  <div class="flex flex-col gap-2">
    <div *ngIf="stats.serviceAuthorizationExpiredPatients > 0" class="flex items-center gap-2">
      <i class="pi pi-exclamation-triangle text-yellow-600"></i>
      <span class="text-yellow-800">
        <strong class="cursor-pointer hover:underline text-blue-600" (click)="navigateToExpiredPatients()">{{
          stats.serviceAuthorizationExpiredPatients
        }}</strong>
        Patients' Service Authorization Date Has Been Expired.
      </span>
    </div>
    <div *ngIf="stats.patientsServiceAuthorizationWillExpireWithinAWeek > 0" class="flex items-center gap-2">
      <i class="pi pi-exclamation-triangle text-yellow-600"></i>
      <span class="text-yellow-800">
        <strong>{{ stats.patientsServiceAuthorizationWillExpireWithinAWeek }}</strong>
        Patients' Service Authorization Date Will Be Expired Within A Week.
      </span>
    </div>
    <div *ngIf="stats.expiredCaregiverCertificateCount > 0" class="flex items-center gap-2">
      <i class="pi pi-exclamation-triangle text-yellow-600"></i>
      <span class="text-yellow-800 cursor-pointer hover" (click)="navigateToExpiredCaregiverCertificates()">
        <strong class="cursor-pointer hover:underline text-blue-600">{{
          stats.expiredCaregiverCertificateCount
        }}</strong>
        Caregivers' Certificate Has Been Expired.
      </span>
    </div>
  </div>
</div>
